import { getProfileByHandle, getProfileVideosByUserId } from "@/api";
import constants from "@/constants";
import userProfileStore from "@/stores/userProfiles";
import type { AnyObject } from "@/types/Any";
import { sanitizeString } from "@mohalla-tech/xss-safeguard";
import { redirect } from "@sveltejs/kit";
import { get } from "svelte/store";
const { NOT_FOUND_URL } = constants;

export const ssr = true;

export const load = async ({ params, fetch, url }) => {
  const { handle: handleWithAt } = params;
  const handle = sanitizeString(handleWithAt.slice(1));
  let start = sanitizeString(url.searchParams.get("start") || "");
  start = start ? Number(start) : 0;
  let profileData: AnyObject = get(userProfileStore).list[handle];

  if (!profileData) {
    try {
      profileData = await getProfileByHandle(fetch, handle);
    } catch (e) {
      console.warn(e);
      return {
        handle,
        start,
      };
    }
  }

  if (profileData.err) {
    throw redirect(302, NOT_FOUND_URL);
  }

  let { videos: list, lp } = profileData;
  if (!list || list.length <= 0) {
    try {
      ({ d: list, lp } = await getProfileVideosByUserId(fetch, profileData.i));
    } catch (e) {
      console.warn(e);
      return {
        handle,
        start,
      };
    }
  }
  return { item: profileData, list, lp, handle, start };
};
